export default __webpack_public_path__ + "static/media/name.f9be5874.svg";